var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-background"},[_c('div',{staticClass:"spinner-container"},[_c('h1',[_vm._v(_vm._s(_vm.text))]),_c('span',{attrs:{"id":"new-spinner"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }